import type { PropsWithChildren, ReactElement } from 'react';

export function AuthContent({ children }: PropsWithChildren): ReactElement {
  return (
    <main className="flex flex-1 items-center justify-center px-4 py-6 md:p-6">{children}</main>
  );
}
